import { render, staticRenderFns } from "./ed-subject-builder-content-sidebar.component.vue?vue&type=template&id=259bcec7&scoped=true&"
import script from "./ed-subject-builder-content-sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-content-sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-content-sidebar.component.scss?vue&type=style&index=0&id=259bcec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259bcec7",
  null
  
)

export default component.exports